import { render } from "./DisPlay.vue?vue&type=template&id=1320280e&scoped=true"
import script from "./DisPlay.vue?vue&type=script&lang=js"
export * from "./DisPlay.vue?vue&type=script&lang=js"

import "./DisPlay.vue?vue&type=style&index=0&id=1320280e&scoped=true&lang=less"

import exportComponent from "E:\\Samples\\学习\\WebPackTest\\my-diary\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1320280e"]])

export default __exports__